<template>
    <div>
        <table-actions-menu>
            <async-table-action-button :callback="editStartDate" :label="trans('tooltips.actions.course_edit_date')">
                <inline-svg
                    :url="require('../../../../images/actions/edit.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </async-table-action-button>

            <async-table-action-button :disabled="!!data.course_deactivated_at" :callback="ComfirmAndReassign" :label="trans('tooltips.actions.course_reassign')">
                <inline-svg
                    :url="require('../../../../images/actions/restore-user.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </async-table-action-button>

            <delete-button
                :url="this.route('tenantapi.users.assignments.destroy', {'user': userId, 'assignment': data.id})"
                :confirmTitle="this.trans('assignments.note.unassign_course_title')"
                :confirmText="this.trans('assignments.note.unassign_course_message')"
                :deleteId="data.id"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import { EventBus } from '../../eventbus';
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';


    export default {
        props: ['data', 'index', 'userId', 'debitClients'],

        components: {
            DeleteButton,
            InlineSvg
        },

        methods: {
            ComfirmAndReassign() {
               this.$alertify.confirmWithTitle(
                    this.trans('assignments.note.reassign_course_title'),
                    this.trans('assignments.note.reassign_course_message'),
                    () => {
                        axios
                            .get(this.route('tenantapi.users.assignments.reassign', {'user': this.userId, 'assignment': this.data.id}))
                            .then(response => {
                                var booking = response.data.data;
                                EventBus.$emit('courseReassigned', [booking, this.index - 1]);
                                this.flash(response);
                            })
                            .catch(error => {
                                this.flash({
                                    message: this.trans('assignments.flash.course_not_reassigned'),
                                    level: 'warning'
                                });
                            });
                    }
                );
            },
            /**
             * Displays a modal with the opportunity to
             */
            editStartDate() {
                this.$modal.show(
                    {
                        template: `
                            <assignment-edit :assignment="assignment" :clients-prop="clients" @close="$emit('close')"></assignment-edit>
                        `,
                        props: ['assignment', 'clients']
                    },
                    {
                        assignment: this.data,
                        clients: this.debitClients,
                    },
                    {
                        height: 'auto',
                        width: '60%',
                        adaptive: true,
                        pivotY: 0.3,
                    },
                    {
                        'before-close': (event) => {
                            EventBus.$emit('refreshCourses');
                        }
                    }
                );
            },
        },
    }
</script>
